import { render, staticRenderFns } from "./roomDialog.vue?vue&type=template&id=0d221f12&scoped=true"
import script from "./roomDialog.vue?vue&type=script&lang=js"
export * from "./roomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d221f12",
  null
  
)

export default component.exports